import {BaseModel, Default} from "@red/data-access";
import {Expose, Type} from "class-transformer";

export class QualificationCreateDto extends BaseModel {
  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  type!: string;

  @Expose()
  @Type(() => Boolean)
  @Default(false)
  isActive!:boolean;
}
